import React, { Component } from "react";
import PropTypes from "prop-types";

import CustomSelectSearchable from "../../CustomSelectSearchable";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { toast } from 'react-toastify';

class CultureRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      area: props.rowData.area,
      volume: props.rowData.volume,
      quality: props.rowData.quality_comment,
      price: props.rowData.price,
      secondRowRadio: true,
      row: '0',
      theBestOffers: [],
      theBestOffer: null,
      transportCoefficient: null,
      marginalProfit: null,
    };
  }

  calculateTheBestOffers = () => {
    const { transportCoefficient, marginalProfit } = this.state;

    this.props.calculateTheBestOffers(this.getGrainId(), transportCoefficient, marginalProfit).subscribe(
        theBestOffers => {
          if (theBestOffers.length) {
            this.setState(prevState => ({
              ...prevState,
              theBestOffers: theBestOffers,
              theBestOffer: theBestOffers[0],
            }));
            return;
          }
          toast.info("Предложения отсутствуют!");
        }
    )
  };

  openSalesOrdersModal = () => {
    this.props.openSalesOrdersModal(
        this.getVolumeId(),
        this.state.price,
        this.state.volume
    )
  };

  handleSelectChange = (name, value) => {
    this.props.onChange(
      name,
      value,
      this.props.rowKey,
      this.props.cultures.find(c => c.value == +value).label
    );
  };

  handleInputChange = e => {
    const field = e.target.name;
    const value = e.target.value;

    this.setState({
      [field]: value,
    });

    this.props.onChange(field, value, this.props.rowKey);
  };


  radioSelected = e => {
    const { rowData } = this.props;
    const { row } = this.state;
    e.persist();
    this.setState({ row: e.target.value });
    if (row === '1') {
      let dataFromFirstRow = {
        contract: rowData.contract[0],
        price_calc: rowData.price_calc[0],
        price_comment: rowData.price_comment[0],
        culture_id: rowData.culture_id
      };
      this.props.radioSelected(dataFromFirstRow);
    }
    if (row === '0') {
      let dataFromSecondRow = {
        contract: rowData.contract[1],
        price_calc: rowData.price_calc[1],
        price_comment: rowData.price_comment[1],
        culture_id: rowData.culture_id
      };
      this.props.radioSelected(dataFromSecondRow);
    }
  };

  getGrainId() {
    const { rowData } = this.props;
    return rowData.culture_id;
  }

  getVolumeId() {
    const { rowData } = this.props;
    return rowData.link_id;
  }

  changeTransportCoefficient = elem => {
    const _value = elem.target.value;

    this.setState({ transportCoefficient : _value })
  };

  changeMarginalProfit = elem => {
    const _value = elem.target.value;

    this.setState({ marginalProfit: _value })
  };

  countSalesOrders()
  {
    if (!this.props.getSalesOrdersByCulture) {
      return 0;
    }

    return this.props.getSalesOrdersByCulture(this.getVolumeId()).length;
  }

  checkHasActiveOrders()
  {
    if (!this.props.getSalesOrdersByCulture) {
      return false;
    }

    return this.props.getSalesOrdersByCulture(this.getVolumeId()).filter(
        salesOrder => salesOrder.isActive()
    ).length > 0
  }

  render() {
    const { rowData, isEditMode, cultures, type } = this.props;
    const { transportCoefficient, marginalProfit } = this.state;

    return (
      <div className="col-xs-12">
        <div className="col-xs-4">
          <div className="clearfix">
            <div className="col-xs-12 custom-form__label with-select">
              Культура:
            </div>
            <div className="col-xs-12">
              <CustomSelectSearchable
                key={Math.random()}
                disabled={this.checkHasActiveOrders()}
                name="culture_id"
                options={cultures}
                placeholder="Выберите культуру"
                values={rowData.culture_id || rowData.id}
                onSelect={this.handleSelectChange}
              />
            </div>
          </div>
          {/* Запросы на onChange */}
          {+type === 1 ? (
            <div className="clearfix mr-top-20">
              <div className="col-xs-3 custom-form__label with-select text-center">
                Площадь, га
              </div>
              <div className="col-xs-2">
                <input
                  disabled={this.checkHasActiveOrders()}
                  type="text"
                  className="custom-form__input"
                  name="area"
                  value={rowData.area}
                  onChange={e => this.setState({ area: e.target.value })}
                />
              </div>
              <div className="col-xs-3 custom-form__label with-select text-center">
                Объем
              </div>
              <div className="col-xs-2">
                <input
                  disabled={this.checkHasActiveOrders()}
                  type="text"
                  className="custom-form__input"
                  name="volume"
                  value={rowData.volume}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          ) : null}
        </div>
        <div className="col-xs-3 col-xs-offset-1">
          <div className="col-xs-10 custom-form__label">Примечание:</div>
          <div className="col-xs-10">
            <textarea
              disabled={this.checkHasActiveOrders()}
              className="custom-form__textarea_tall"
              value={rowData.quality_comment || ""}
              name="quality_comment"
              onChange={this.handleInputChange}
            />
          </div>
        </div>
        <div className="col-xs-4">
          {+type === 1 ? (
            <div>
              <div className="col-xs-6">
                <div className="clearfix mr-bottom-20 mr-right-20">
                  <div className="col-xs-6 custom-form__label double-line">
                    Цена <span className="description">желаемая</span>:
                  </div>
                  <div className="col-xs-6">
                    <input
                      disabled={this.checkHasActiveOrders()}
                      type="text"
                      className="custom-form__input"
                      name="price"
                      value={rowData.price}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
              </div>
              {isEditMode ? (
                <div className="col-xs-12">
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginTop: 5
                    }}
                  >
                    {rowData.multipleItems && (
                      <input
                        style={{ marginRight: 5, marginTop: 3 }}
                        type="radio"
                        value={0}
                        name="typeOfDeal"
                        defaultChecked
                        onClick={this.radioSelected}
                      />
                    )}
                    <div
                      className=" custom-form__label"
                      style={{
                        flexGrow: 1
                      }}
                    >
                      Цена
                    </div>
                    {this.state.theBestOffer ? (
                      <div
                        className="custom-form__label"
                        style={{
                          flexGrow: 1
                        }}
                      >
                        Дог-р.:{" "}
                        {this.state.theBestOffer.hasContractLabel}
                      </div>
                    ) : null}
                    <div className=" text-center">
                      {this.state.theBestOffer ? ( this.state.theBestOffer.estimatedPrice ) : "Н/д"}
                    </div>
                  </div>

                  {/* 2я Строка */}
                  {rowData.multipleItems && (
                    <div
                      className=""
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: 5
                      }}
                    >
                      {typeof rowData.price_calc !== "string" && (
                        <input
                          style={{ marginRight: 5, marginTop: 3 }}
                          type="radio"
                          name="typeOfDeal"
                          value={1}
                          onClick={this.radioSelected}
                        />
                      )}
                      <div
                        className=" custom-form__label"
                        style={{
                          flexGrow: 1
                        }}
                      >
                        Цена
                      </div>
                      {typeof rowData.price_calc !== "string" ? (
                        <div
                          className="custom-form__label"
                          style={{
                            flexGrow: 1
                          }}
                        >
                          Дог-р.: {rowData.contract[1] ? "есть" : "нет"}
                        </div>
                      ) : null}
                      <div className=" text-center">
                        {rowData.price_calc[1]} {rowData.price_comment[1]}
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
              {isEditMode && rowData.link_id ? (
                <div className="clearfix">
                  <button
                      className="btn btn-success mr-bottom-20 mr-top-20"
                      type="button"
                      onClick={this.calculateTheBestOffers}
                  >
                    Обновить расчетную цену
                  </button>

                </div>
              ) : null}
              {isEditMode && rowData.link_id ? (
                <div className="clearfix">
                  <button
                      className="btn btn-success mr-bottom-20 mr-top-20"
                      type="button"
                      onClick={this.openSalesOrdersModal}
                  >
                    Заявки на продажу ({this.countSalesOrders()})
                  </button>

                </div>
              ) : null}
            </div>
          ) : (
              <div className="row">
                <div className="col-xs-6">
                  <div className="clearfix mr-bottom-20 mr-right-20">
                    <div className="col-xs-6 custom-form__label double-line">
                      Цена желаемая:
                  </div>
                    <div className="col-xs-6">
                      <input
                        type="text"
                        className="custom-form__input"
                        name="price"
                        value={rowData.price}
                        onChange={this.handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="clearfix mr-bottom-20 mr-right-20">
                    <div className="col-xs-6 custom-form__label double-line">
                      Объем:
                  </div>
                    <div className="col-xs-6">
                      <input
                        type="text"
                        className="custom-form__input"
                        value={rowData.volume}
                        name="volume"
                        onChange={this.handleInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>

        {this.state.theBestOffers.length ? (
            <div>
              <h3>Лучшие предложения</h3>
              <div className="clearfix mr-top-20 clearfix_supplier">
                <div className="col-xs-3 custom-form__label with-select text-center culture_row_margin">
                  Маржа
                </div>
                <div className="col-xs-2 culture_row_div_input">
                  <input
                    type="number"
                    className="custom-form__input"
                    value={marginalProfit}
                    onChange={this.changeMarginalProfit}
                  />
                </div>
                <div className="col-xs-3 custom-form__label with-select text-center culture_row_coef_delivery">
                  Коэф. доставки
                </div>
                <div className="col-xs-2 culture_row_div_input">
                  <input
                    type="number"
                    className="custom-form__input"
                    value={transportCoefficient}
                    onChange={this.changeTransportCoefficient}
                  />
                </div>
              </div>
              <div className="row mr-bottom-20">
                <ReactTable
                    data={this.state.theBestOffers}
                    columns={[
                      {
                        Header: "Название переработчика",
                        columns: [
                          {
                            accessor: "companyName",
                            minWidth: 250
                          }
                        ]
                      },
                      {
                        Header: "Адрес переработчика",
                        columns: [
                          {
                            accessor: "companyAddress",
                            minWidth: 300
                          }
                        ]
                      },
                      {
                        Header: "Расчетная цена",
                        columns: [
                          {
                            accessor: "estimatedPriceLabel",
                            minWidth: 125
                          }
                        ]
                      },
                      {
                        Header: "Закупочная цена",
                        columns: [
                          {
                            accessor: "purchasePrice",
                            minWidth: 150
                          }
                        ]
                      },
                      {
                        Header: "Маржинальная прибыль",
                        columns: [
                          {
                            accessor: "marginalProfit",
                            minWidth: 150

                          }
                        ]
                      },
                      {
                        Header: "Дистанция",
                        columns: [
                          {
                            accessor: "deliveryDistanceLabel"
                          }
                        ]
                      },
                      {
                        Header: "Цена перевозки",
                        columns: [
                          {
                            accessor: "deliveryPriceLabel",
                            minWidth: 125
                          }
                        ]
                      },
                      {
                        Header: "Наличие договора",
                        columns: [
                          {
                            accessor: "hasContractLabel",
                            minWidth: 150
                          }
                        ]
                      },
                    ]}
                    minRows={1}
                    showPagination={false}
                    className="-striped"
                />
              </div>
            </div>
          ) : null }

      </div>
    );
  }
}

CultureRow.propTypes = {
  cultures: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  rowKey: PropTypes.number,
  rowData: PropTypes.object,
  isEditMode: PropTypes.bool,
  type: PropTypes.number,
  calculateTheBestOffers: PropTypes.func,
  openSalesOrdersModal: PropTypes.func,
  getSalesOrdersByCulture: PropTypes.func,
};

export default CultureRow;



// WEBPACK FOOTER //
// ./components/ClientForm/Cultures/CultureRow.js